var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"col-12 alert alert-secondary text-center"},[_c('span',[_vm._v(_vm._s(_vm.listLength + ' ' + _vm.countResult + ' ' + (_vm.listLength > 1 ? _vm.meetPlural : _vm.meetSingular) + ' ' + _vm.selectionCriteria))])])}
var staticRenderFns = []

export { render, staticRenderFns }